import React, { useContext } from 'react'
import StepFigure from 'app/React/Components/Main/StepFigure'
import FormStep3 from "app/React/Components/Form/Step3/FormStep3"
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function Step3() {
  const {
    currentVariant,
    setCurrentStep,
  } = useContext(ConfiguratorContext)

  const steps = currentVariant.steps ?? {}

  if (steps['3'] === undefined) {
    setCurrentStep('4')
    return null
  }

  return (
    <div id='step-3'>
      <StepFigure step={steps['3'].step_id}/>
      <FormStep3 form={steps['3']}/>
    </div>
  )
}
